import { GLProgram } from "../../../program.js";
export class DensityProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/tools/density/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/tools/density/fragment.glsl');
        var result = new DensityProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['stroke_mask'] = gl.getUniformLocation(result._program, 'u_stroke_mask');
        result._uniforms['plus'] = gl.getUniformLocation(result._program, 'u_plus');
        result._uniforms['exposure'] = gl.getUniformLocation(result._program, 'u_exposure');
        return result;
    }

    setUniforms(parameters) {
        var self = this;
        self._gl.uniform1i(self.uniformLocation('plus'), parameters.plus);
        self._gl.uniform1f(self.uniformLocation('exposure'), parameters.exposure);
    }

}